export { VpCaptionEditor } from './VpCaptionEditor';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpCaptionEditor/index.js